import { render, staticRenderFns } from "./deptId.vue?vue&type=template&id=39958ee0&"
import script from "./deptId.vue?vue&type=script&lang=js&"
export * from "./deptId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/deptId.vue"
export default component.exports